/**
 * @file
 * Behaviors for the Navbar Search block.
 */

/* eslint-disable max-len */

(function (Drupal) {
  Drupal.behaviors.navbarSearch = {
    attach: () => {
      const showButton = document.querySelector('.navbar-search__btn');
      const hiddenFormItem = document.querySelector(
        '#search-block-form .form-type-search'
      );
      const hiddenFormField = document.querySelector(
        '#search-block-form  .form-search'
      );
      const hiddenFormButton = document.querySelector(
        '#search-block-form  .form-submit'
      );

      // Hide form field, set tabIndex.
      const hide = () => {
        hiddenFormItem.setAttribute('data-visibility', 'hide');
        showButton.style.display = 'flex';
        hiddenFormField.tabIndex = -1;
        hiddenFormButton.tabIndex = -1;
        hiddenFormButton.style.display = 'none';
      };

      // Show the form, reset tabIndex, set focus.
      const show = () => {
        hiddenFormItem.setAttribute('data-visibility', 'show');
        hiddenFormField.focus();
        showButton.style.display = 'none';
        hiddenFormButton.style.display = 'flex';
        hiddenFormField.removeAttribute('tabIndex');
        hiddenFormButton.removeAttribute('tabIndex');
      };

      // Button to expand search block.
      showButton.onclick = function () {
        console.log('clicked');
        if (hiddenFormItem.getAttribute('data-visibility') === 'show') {
          hide();
        }
        else {
          show();
          showButton.focus();
        }
      };

      // Hide search form on load.
      hide();

      // Need function to close if clicking outside off element.
      window.addEventListener('click', function (e) {
        if (
          !document.getElementById('navbar-search').contains(e.target) &&
          hiddenFormItem.getAttribute('data-visibility') === 'show'
        ) {
          hide();
        }
      });

      // Handle `ESC` key and collapse.
      window.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          hide();
          showButton.focus();
        }
      });
    }
  };
})(Drupal);

// Move the second search block into navigation.
(function (Drupal, once) {
  Drupal.behaviors.mobileSearch = {
    attach: (context) => {
      once('mobileSearch', '.search-swap', context).forEach((destination) => {
        const SearchBlock = document.querySelector(
          '#block-lehigh-search-form-mobile'
        );

        if (SearchBlock) {
          destination.replaceWith(SearchBlock);
        }
      });
    }
  };
  // eslint-disable-next-line no-undef
})(Drupal, once);
